import amplitude from 'utils/amplitude';
import { EnumEvents } from 'constants/enums';
import { IShopForPlace } from 'Modules/Shops/types';

export default function selectShopAnalytic(CurrentOrderId: number, shop: IShopForPlace): void {
  const { id, group_en, group } = shop;

  amplitude.logEvent(EnumEvents.SELECT_SHOP, {
    'order id': CurrentOrderId,
    'shop id': id,
    'shop group': group_en || group,
  });
}
